import {
  CREATE_FILE_METADATA_FAILED,
  CREATE_FILE_METADATA_SUCCEEDED,
  FETCH_S3_PRESIGNED_URLS,
  FETCH_S3_PRESIGNED_URLS_SUCCEEDED,
  INCREMENT_LAST_UPLOAD_ID,
  RESET_FILE_UPLOAD_STORE,
  UPLOAD_FILES_FAILED,
  UPLOAD_FILES_PROGRESS,
  UPLOAD_FILES_SUCCEEDED,
} from 'Redux/Types/UploadFileTypes'

import { FILE_UPLOAD_STATE } from 'Constants'

const INITIAL_STATE = {
  fetchingS3URLs: false,
  lastUploadID: 0,
  uploads: {},
}

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_S3_PRESIGNED_URLS: {
      return { ...state, fetchingS3URLs: true }
    }

    case FETCH_S3_PRESIGNED_URLS_SUCCEEDED: {
      return { ...state, fetchingS3URLs: false }
    }

    case INCREMENT_LAST_UPLOAD_ID: {
      return { ...state, lastUploadID: state.lastUploadID + 1 }
    }

    case UPLOAD_FILES_PROGRESS: {
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [payload.id]: {
            ...state.uploads[payload.id],
            ...payload,
            status: FILE_UPLOAD_STATE.UPLOADING,
          },
        },
      }
    }

    case UPLOAD_FILES_SUCCEEDED: {
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [payload.id]: {
            ...state.uploads[payload.id],
            ...payload,
            status: FILE_UPLOAD_STATE.PROCESSING,
          },
        },
      }
    }

    case CREATE_FILE_METADATA_FAILED:
    case UPLOAD_FILES_FAILED: {
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [payload.id]: {
            ...state.uploads[payload.id],
            ...payload,
            status: FILE_UPLOAD_STATE.FAILED,
            failures: payload.failures || [payload],
          },
        },
      }
    }

    case CREATE_FILE_METADATA_SUCCEEDED: {
      return {
        ...state,
        uploads: {
          ...state.uploads,
          [payload.id]: {
            ...state.uploads[payload.id],
            ...payload,
            status: FILE_UPLOAD_STATE.COMPLETE,
          },
        },
      }
    }

    case RESET_FILE_UPLOAD_STORE:
      return INITIAL_STATE

    default:
      return state
  }
}
